import {fork} from 'redux-saga/effects';

import {sagas as investInvite} from './invite';
import {sagas as investAgreement} from './agree';
import {sagas as investConfirmed} from './confirmed';

export function* sagas() {
  yield fork(investInvite);
  yield fork(investAgreement);
  yield fork(investConfirmed);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/invest/index.js